const T = {
  pl: {
    app_title: "Kalkulator do świec",
    app_subtitle: "Oblicz dokładną masę olejku zapachowego i wosku dla Twojej świecy.",

    mode_topwosk: "Olejek TopWosk",
    mode_other: "Inny olejek",
    mode_note: "Kalkulator działa dla każdego olejku. Tylko przy olejkach TopWosk zobaczysz pełną klasyfikację CLP i gotowe dokumenty.",

    clp_custom_sds_title: "Niestandardowe stężenie wymaga indywidualnej karty charakterystyki",
    clp_custom_sds_text: "Nasza karta charakterystyki jest przygotowana dla stężeń 6%, 8% i 10%. Przy stężeniu <strong>{conc}%</strong> podany w karcie skład mieszaniny nie odpowiada Twojej faktycznej recepturze i wymaga aktualizacji.",

    other_warning_title: "⚠️ Brak danych klasyfikacyjnych dla tego olejku",
    other_warning_text: "Nie jesteśmy w stanie określić, czy przy wybranym stężeniu Twoja świeca wymaga piktogramów GHS, kodu UFI oraz zgłoszenia PCN. Klasyfikacja musi zostać dostarczona przez producenta olejku lub wykonana przez zewnętrznego chemika. Koszt takiej klasyfikacji wynosi zazwyczaj od 200 do 500 zł za jeden zapach. W ofercie TopWosk komplet dokumentów klasyfikacyjnych dla 6/8/10% otrzymujesz za darmo.",
    other_warning_cta: "Zobacz olejki TopWosk →",

    compare_note_always: "⚠ Niezależnie od wyniku klasyfikacji CLP, każda świeca zapachowa wymaga etykiety ostrzegawczej zgodnej z normą PN-EN 15494 oraz dokumentacji GPSR (m.in. oceny ryzyka i danych producenta). Etykietę PN-EN 15494 wygenerujesz bezpłatnie w <a href=\"{labelUrl}\" target=\"_blank\" rel=\"noopener\">Generatorze Etykiet TopWosk</a>.",
    compare_note_euh208: "<strong>*</strong> Brak pełnej klasyfikacji CLP, ale olejek zawiera składniki alergenowe. Na etykiecie świecy musi znaleźć się tekst „Zawiera…\" (EUH208). Etykietę dla stężenia 6%, 8% lub 10% stworzysz w <a href=\"{labelUrl}\" target=\"_blank\" rel=\"noopener\">Generatorze Etykiet TopWosk</a>.",
    compare_note_pcn: "<strong>**</strong> Kwota 125 zł obejmuje zgłoszenie PCN realizowane przez naszego partnera (Chemtra) na podstawie karty charakterystyki dostarczonej przez TopWosk. Dla porównania, zewnętrzny chemik pobiera za analogiczną usługę zazwyczaj od 200 do 500 zł za jeden olejek.",

    lbl_product_type: "Rodzaj produktu",
    pt_candles: "Świece",
    lbl_fragrance: "Wybierz olejek z oferty TopWosk",
    frag_placeholder: "Wyszukaj lub wybierz olejek...",
    lbl_mass: "Masa",
    suffix_g: "g",
    lbl_count: "Ilość świec",
    suffix_pcs: "szt.",
    lbl_concentration: "Stężenie olejku <span class=\"lbl-hint\">(możesz wpisać wartość)</span>",

    res_oil: "Masa olejku",
    res_wax: "Masa wosku",
    res_total_oil: "Łącznie olejku",
    res_total_wax: "Łącznie wosku",

    sec_compare: "Porównanie stężeń",
    tbl_oil_mass: "Masa olejku",
    tbl_classification: "Klasyfikacja",
    tbl_pictos: "Piktogramy",
    tbl_ufi: "UFI wymagany",
    tbl_pcn: "PCN wymagany",
    tbl_cost: "Koszt formalności",
    val_yes: "Tak",
    val_no: "Nie",
    val_none: "Brak",
    val_classified: "Klasyfikowana",

    sec_kch: "Karta charakterystyki (SDS)",
    kch_download: "Pobierz PDF",
    kch_missing: "Brak pliku",

    cat_Owocowe: "Owocowe",
    cat_Kwiatowe: "Kwiatowe",
    "cat_Słodkie / Deserowe": "Słodkie / Deserowe",
    "cat_Korzenne / Orientalne": "Korzenne / Orientalne",
    "cat_Świeże / Zielone": "Świeże / Zielone",
    "cat_Drzewne / Męskie": "Drzewne / Męskie",
    cat_Inne: "Inne",
    cat_Pozostałe: "Pozostałe",
    dd_empty: "Brak wyników",

    badge_pcn_tooltip: "Olejek wymaga zgłoszenia PCN przy stężeniu 6%, 8% lub 10%",
    badge_euh208_tooltip: "Olejek wymaga dodatkowego tekstu na etykiecie (EUH208 lub zwrot środowiskowy), bez UFI/PCN",

    clp_none: "Brak klasyfikacji",
    clp_env: "Klasyfikacja środowiskowa",
    clp_euh208: "Tylko ostrzeżenie alergenowe",
    clp_full: "Pełna klasyfikacja CLP",
    clp_above_limit: "Stężenie poza zakresem",

    clp_above_limit_text: "Dla stężeń powyżej <strong>10%</strong> nie dysponujemy danymi klasyfikacyjnymi. Wybierz stężenie <strong>10% lub niższe</strong>.",
    clp_bucketed_note: "Klasyfikacja CLP jest monotoniczna, więc niższe stężenie olejku nie może skutkować surowszymi wymogami. Przy <strong>{conc}%</strong> obowiązki nie przekroczą tych dla stężenia <strong>{bucket}%</strong> (dane poniżej).",
    clp_clean_text: "Przy stężeniu <strong>{conc}%</strong> świeca z olejkiem <strong>{name}</strong> <strong>nie wymaga</strong> klasyfikacji CLP.",
    clp_euh208_text: "Przy stężeniu <strong>{conc}%</strong> świeca z olejkiem <strong>{name}</strong> nie wymaga pełnej klasyfikacji CLP, ale na etykiecie musi się znaleźć <strong>tekst alergenowy (EUH208)</strong>. UFI ani zgłoszenie PCN nie są wymagane.",
    clp_env_text: "Przy stężeniu <strong>{conc}%</strong> świeca z olejkiem <strong>{name}</strong> wymaga jedynie zwrotu o zagrożeniu środowiskowym. <strong>Nie wymaga</strong> UFI ani zgłoszenia PCN.",
    clp_bad_text: "Przy stężeniu <strong>{conc}%</strong> świeca z olejkiem <strong>{name}</strong> wymaga <strong>pełnej etykiety CLP</strong> z kodem UFI i zgłoszeniem PCN.",

    clp_h_label: "Zwrot H",
    clp_contains_label: "Tekst alergenowy (EUH208)",

    clp_li_no_picto: "Brak piktogramów GHS",
    clp_li_no_ufi: "Brak wymogu UFI",
    clp_li_no_pcn: "Brak zgłoszenia PCN",
    clp_li_no_cost: "Koszt formalności: 0 zł",
    clp_li_euh208_required: "Na etykiecie wymagany tekst „Zawiera…\" (EUH208)",
    clp_li_env_picto: "Piktogram: {pictos}",
    clp_li_env_no_ufi: "UFI nie jest wymagany (klasyfikacja środowiskowa)",
    clp_li_env_no_pcn: "Zgłoszenie PCN nie jest wymagane",
    clp_li_bad_picto: "Piktogramy: {pictos}",
    clp_li_bad_signal: "Hasło ostrzegawcze: {signal}",
    clp_li_bad_ufi: "Kod UFI wymagany",
    clp_li_bad_pcn: "Zgłoszenie PCN wymagane ({cost} zł przez Chemtra)",

    signal_warning: "Uwaga",
    signal_danger: "Niebezpieczeństwo",

    picto_exclamation: "wykrzyknik (GHS07)",
    picto_health: "zagrożenie zdrowia (GHS08)",
    picto_environment: "środowisko (GHS09)",
    picto_flame: "płomień (GHS02)",
    picto_corrosion: "żrący (GHS05)",
    picto_oxidizer: "utleniacz (GHS03)",
    picto_none: "brak"
  },
  en: {
    app_title: "Candle calculator",
    app_subtitle: "Calculate exact fragrance oil and wax mass for your candle.",

    mode_topwosk: "TopWosk oil",
    mode_other: "Other oil",
    mode_note: "The calculator works with any oil. But only with TopWosk oils you'll see the full CLP classification and ready-to-use documents.",

    clp_custom_sds_title: "Non-standard concentration requires a custom safety data sheet",
    clp_custom_sds_text: "Our safety data sheet is prepared for concentrations of 6%, 8% and 10%. At a concentration of <strong>{conc}%</strong> the composition of the mixture stated in the sheet does not match your actual formulation and needs to be updated.",

    other_warning_title: "⚠️ No classification data available for this oil",
    other_warning_text: "We are unable to determine whether your candle, at the selected concentration, requires GHS pictograms, a UFI code or PCN notification. Classification must be provided by the oil manufacturer or performed by an external chemist. The typical cost of such classification ranges from 200 to 500 PLN per fragrance. With TopWosk oils, the full classification package for 6/8/10% is provided free of charge.",
    other_warning_cta: "Browse TopWosk oils →",

    compare_note_always: "⚠ Regardless of the CLP outcome, every scented candle requires a warning label compliant with the PN-EN 15494 standard and GPSR documentation (including risk assessment and manufacturer data). The PN-EN 15494 label can be generated free of charge in the <a href=\"{labelUrl}\" target=\"_blank\" rel=\"noopener\">TopWosk Label Generator</a>.",
    compare_note_euh208: "<strong>*</strong> No full CLP classification, but the oil contains allergenic components. The candle label must include a \"Contains…\" statement (EUH208). You can create the label for 6%, 8% or 10% in the <a href=\"{labelUrl}\" target=\"_blank\" rel=\"noopener\">TopWosk Label Generator</a>.",
    compare_note_pcn: "<strong>**</strong> The 125 PLN amount covers PCN notification performed by our partner (Chemtra), based on the safety data sheet provided by TopWosk. For comparison, an external chemist typically charges between 200 and 500 PLN per fragrance for the same service.",

    lbl_product_type: "Product type",
    pt_candles: "Candles",
    lbl_fragrance: "Choose an oil from the TopWosk offer",
    frag_placeholder: "Search or choose a fragrance oil...",
    lbl_mass: "Mass",
    suffix_g: "g",
    lbl_count: "Number of candles",
    suffix_pcs: "pcs",
    lbl_concentration: "Oil concentration <span class=\"lbl-hint\">(you can type a value)</span>",

    res_oil: "Oil mass",
    res_wax: "Wax mass",
    res_total_oil: "Total oil",
    res_total_wax: "Total wax",

    sec_compare: "Concentration comparison",
    tbl_oil_mass: "Oil mass",
    tbl_classification: "Classification",
    tbl_pictos: "Pictograms",
    tbl_ufi: "UFI required",
    tbl_pcn: "PCN required",
    tbl_cost: "Paperwork cost",
    val_yes: "Yes",
    val_no: "No",
    val_none: "None",
    val_classified: "Classified",

    sec_kch: "Safety Data Sheet (SDS)",
    kch_download: "Download PDF",
    kch_missing: "File unavailable",

    cat_Owocowe: "Fruity",
    cat_Kwiatowe: "Floral",
    "cat_Słodkie / Deserowe": "Sweet / Dessert",
    "cat_Korzenne / Orientalne": "Spicy / Oriental",
    "cat_Świeże / Zielone": "Fresh / Green",
    "cat_Drzewne / Męskie": "Woody / Masculine",
    cat_Inne: "Other",
    cat_Pozostałe: "Other",
    dd_empty: "No results",

    badge_pcn_tooltip: "Oil requires PCN notification at 6%, 8% or 10% concentration",
    badge_euh208_tooltip: "Oil requires additional label text (EUH208 or environmental statement), no UFI/PCN",

    clp_none: "No classification",
    clp_env: "Environmental classification",
    clp_euh208: "Allergen statement only",
    clp_full: "Full CLP classification",
    clp_above_limit: "Concentration out of range",

    clp_above_limit_text: "Classification data is not available for concentrations above <strong>10%</strong>. Choose a concentration of <strong>10% or lower</strong>.",
    clp_bucketed_note: "CLP classification is monotonic, so a lower oil concentration cannot produce stricter obligations. At <strong>{conc}%</strong> the requirements will not exceed those for <strong>{bucket}%</strong> (classification below).",
    clp_clean_text: "At a concentration of <strong>{conc}%</strong>, a candle with <strong>{name}</strong> oil <strong>does not require</strong> CLP classification.",
    clp_euh208_text: "At a concentration of <strong>{conc}%</strong>, a candle with <strong>{name}</strong> oil does not require full CLP classification, but the label must carry an <strong>allergen statement (EUH208)</strong>. No UFI or PCN notification is needed.",
    clp_env_text: "At a concentration of <strong>{conc}%</strong>, a candle with <strong>{name}</strong> oil requires only an environmental hazard statement. <strong>No</strong> UFI or PCN notification is needed.",
    clp_bad_text: "At a concentration of <strong>{conc}%</strong>, a candle with <strong>{name}</strong> oil requires a <strong>full CLP label</strong> with UFI code and PCN notification.",

    clp_h_label: "H statement",
    clp_contains_label: "Allergen statement (EUH208)",

    clp_li_no_picto: "No GHS pictograms",
    clp_li_no_ufi: "No UFI required",
    clp_li_no_pcn: "No PCN notification",
    clp_li_no_cost: "Paperwork cost: 0 PLN",
    clp_li_euh208_required: "\"Contains…\" statement (EUH208) required on the label",
    clp_li_env_picto: "Pictogram: {pictos}",
    clp_li_env_no_ufi: "UFI is not required (environmental classification)",
    clp_li_env_no_pcn: "PCN notification is not required",
    clp_li_bad_picto: "Pictograms: {pictos}",
    clp_li_bad_signal: "Signal word: {signal}",
    clp_li_bad_ufi: "UFI code required",
    clp_li_bad_pcn: "PCN notification required ({cost} PLN via Chemtra)",

    signal_warning: "Warning",
    signal_danger: "Danger",

    picto_exclamation: "exclamation (GHS07)",
    picto_health: "health hazard (GHS08)",
    picto_environment: "environment (GHS09)",
    picto_flame: "flame (GHS02)",
    picto_corrosion: "corrosion (GHS05)",
    picto_oxidizer: "oxidizer (GHS03)",
    picto_none: "none"
  }
};
